import React, { useState } from 'react'
import Text from 'core/elements/Text'
import { DialogActions, Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import Button from 'core/elements/button'
import Progress from 'core/components/progress/Progress'
import { deAuthNode } from 'app/plugins/infrastructure/components/nodes/actions'
import useDataUpdater from 'core/hooks/useDataUpdater'
import ListTable from 'core/components/listTable/ListTable'
import { INodesSelector } from './model'
import { stopPropagation } from 'utils/fp'

interface IDeauthNodeDialogProps {
  nodeList: INodesSelector[]
  onClose: () => void
}

interface IDeauthNode {
  uuid: string
  name: string
  primaryIp: string
  role: string
}

type IHandleOnSelectAll = (selectedNode: IDeauthNode[], isSelected: boolean) => void
type IHandleDeauthNodeSelection = (selectedNode: IDeauthNode, isSelected) => void
type IGetNodeList = (nodeList: any[]) => IDeauthNode[]

const column = [
  { id: 'name', label: 'Name' },
  { id: 'status', label: 'Status' },
  { id: 'primaryIp', label: 'IP' },
  { id: 'role', label: 'Role' },
]

const getNodeList: IGetNodeList = (nodeList) =>
  nodeList.map(({ uuid, status, primaryIp, name, isMaster }) => {
    const healthStatus =
      status === 'disconnected' ? 'unknown' : status === 'ok' ? 'healthy' : 'unhealthy'
    const role = isMaster ? 'Master' : 'Worker'
    return { uuid, name, status: healthStatus, primaryIp, role }
  })

const DeauthNodeDialog: React.FunctionComponent<IDeauthNodeDialogProps> = ({
  nodeList,
  onClose,
}) => {
  const [selectedNodeList, setSelectedNodeList] = useState([])
  const [deAuthNodeList, deAuthingNode] = useDataUpdater(deAuthNode, onClose)
  const handleDelete = async () => {
    // TODO: Need to handle the error case depending on rest API
    // when refactoring to new actions, use params in commented line
    // await Promise.all(selectedNodeList.map((node) => deAuthNodeList({ node })))
    await Promise.all(selectedNodeList.map((node) => deAuthNodeList(node)))
  }
  const nodeData: IDeauthNode[] = getNodeList(nodeList)
  const handleDeauthNodeSelection: IHandleDeauthNodeSelection = (selectedNode, isSelected) => {
    if (isSelected) {
      setSelectedNodeList(selectedNodeList.filter((node) => node.uuid !== selectedNode.uuid))
    } else {
      setSelectedNodeList(selectedNodeList.concat([selectedNode]))
    }
  }

  const handleOnSelectAll: IHandleOnSelectAll = (selectedNodes, selected) => {
    selected ? setSelectedNodeList(selectedNodes) : setSelectedNodeList([])
  }

  return (
    <Dialog open onClose={onClose} onClick={stopPropagation}>
      <DialogTitle>Deauthorise nodes?</DialogTitle>
      <Progress loading={deAuthingNode} renderContentOnMount>
        <DialogContent>
          <Text variant="body1" component="div">
            Please select the node from to list to de-authorise.
          </Text>
          <ListTable
            compactTable
            multiSelection
            columns={column}
            data={nodeData}
            selectedRows={selectedNodeList}
            onSelect={handleDeauthNodeSelection}
            onSelectAll={handleOnSelectAll}
          />
        </DialogContent>
      </Progress>
      <DialogActions>
        <Button onClick={onClose} variant="secondary">
          Cancel
        </Button>
        {selectedNodeList.length > 0 && (
          <Button type="submit" onClick={handleDelete}>
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default DeauthNodeDialog
